import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantRelationshipPage = {
  alert: {
    error: 'coapplicant-relationship-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-relationship-page.footer.root',
  },
  form: {
    h1: 'coapplicant-relationship-page.form.h1',
    h2: 'coapplicant-relationship-page.form.h2',
    radioGroupRoot: 'coapplicant-relationship-page.form.radio-group-root',
    radioOption1: 'coapplicant-relationship-page.form.radio-option1',
    radioOption2: 'coapplicant-relationship-page.form.radio-option2',
    radioOption3: 'coapplicant-relationship-page.form.radio-option3',
    radioOption4: 'coapplicant-relationship-page.form.radio-option4',
    radioOption5: 'coapplicant-relationship-page.form.radio-option5',
    root: 'coapplicant-relationship-page.form.root',
    submitButton: 'coapplicant-relationship-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
